{
  "name": "'t Claverblat — estimated placement",
  "quayReading": "damrak-west-papen-oudebrug-18",
  "dikeReading": "nieuwendijk-zout-oudebrug-23",
  "accessReading": "damrak-west-papen-oudebrug-17",
  "alleyWidth": 1,
  "sources": [
    { "url": "https://www.theobakker.net/pdf/DamrakI_JB79.pdf", "pages": [35, 38, 39, 43, 52, 53] },
    { "url": "https://www.theobakker.net/pdf/DamrakIV_JB82.pdf", "pages": [75, 76, 78, 80, 82] }
  ],
  "notes": [
    "The connected Nieuwendijk house, spijker and quay house are documented. Their association with these frontage entries is estimated from the parcel location and retained street geometry, not an identified house census.",
    "The quay proportions and unequal floor heights approximate Zantkuijl's section labelled 1539. Applying them to 1538 is a reconstruction; the two doors follow the identified 1544 detail. Exact openings and roof material are not measured by this section.",
    "The five-metre quay courtyard follows the described separation. Spijker dimensions, the second courtyard, neighbouring rear boundaries and the Nieuwendijk body are estimates. The private passage represents the documented southern alley access, not an exact cadastral identification of the adjacent entries. Street front lines and painted roof picks stay fixed."
  ],
  "quay": { "width": 6.8, "depth": 19.5, "floors": [4.8, 3.2, 2.3, 2.2], "roofRise": 7.2 },
  "yard": 5,
  "spijker": { "width": 6, "depth": 7.5, "storeys": 2, "storeyHeight": 3.1 },
  "dike": { "width": 6.8, "depth": 17, "storeys": 2, "storeyHeight": 3.4 }
}
